"use client";

import React from "react";
import { Loader, Sparkles } from "lucide-react";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Card } from "@/components/ui/card";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
function InquiryFormContent() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <div className="flex flex-col items-center justify-center h-full py-12 text-center space-y-6 animate-in fade-in duration-500">
        <div className="size-16 rounded-lg bg-primary/10 flex items-center justify-center mb-4">
          <Sparkles className="size-8 text-primary" />
        </div>
        <h3 className="text-2xl font-serif text-foreground">¡Consulta Recibida!</h3>
        <p className="text-muted-foreground max-w-md">
          {successMessage}
        </p>
        <Button onClick={resetForm} variant="outline" className="mt-8 border-primary/50 hover:bg-primary/10">
          Enviar otra consulta
        </Button>
      </div>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <FormField control={control} name="category" rules={{
      required: "Por favor seleccione una categoría"
    }} render={({
      field
    }) => <FormItem className="space-y-4">
            <FormLabel className="text-base font-serif text-foreground/90">Categoría interesada</FormLabel>
            <FormControl>
              <RadioGroup onValueChange={field.onChange} defaultValue={field.value} className="flex flex-col space-y-2 sm:flex-row sm:space-y-0 sm:space-x-6">
                <FormItem className="flex items-center space-x-3 space-y-0">
                  <FormControl>
                    <RadioGroupItem value="Aéreo" />
                  </FormControl>
                  <FormLabel className="font-normal text-muted-foreground cursor-pointer">
                    Aéreo
                  </FormLabel>
                </FormItem>
                <FormItem className="flex items-center space-x-3 space-y-0">
                  <FormControl>
                    <RadioGroupItem value="Terrestre" />
                  </FormControl>
                  <FormLabel className="font-normal text-muted-foreground cursor-pointer">
                    Terrestre
                  </FormLabel>
                </FormItem>
                <FormItem className="flex items-center space-x-3 space-y-0">
                  <FormControl>
                    <RadioGroupItem value="Buenos Aires" />
                  </FormControl>
                  <FormLabel className="font-normal text-muted-foreground cursor-pointer">
                    Buenos Aires
                  </FormLabel>
                </FormItem>
                <FormItem className="flex items-center space-x-3 space-y-0">
                  <FormControl>
                    <RadioGroupItem value="Paquetes" />
                  </FormControl>
                  <FormLabel className="font-normal text-muted-foreground cursor-pointer">
                    Paquetes
                  </FormLabel>
                </FormItem>
              </RadioGroup>
            </FormControl>
            <FormMessage />
          </FormItem>} />

      <div className="space-y-6">
        <FormField control={control} name="name" rules={{
        required: "El nombre es obligatorio",
        minLength: {
          value: 2,
          message: "Mínimo 2 caracteres"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-foreground/80">Nombre Completo</FormLabel>
              <FormControl>
                <Input placeholder="Ej. Juan Pérez" className="bg-background/50 border-border/30 focus-visible:border-primary" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <FormField control={control} name="email" rules={{
          required: "El correo es obligatorio",
          pattern: {
            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
            message: "Correo electrónico inválido"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/80">Correo Electrónico</FormLabel>
                <FormControl>
                  <Input type="email" placeholder="juan@ejemplo.com" className="bg-background/50 border-border/30 focus-visible:border-primary" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />

          <FormField control={control} name="phone" rules={{
          required: "El teléfono es obligatorio",
          minLength: {
            value: 5,
            message: "Número demasiado corto"
          }
        }} render={({
          field
        }) => <FormItem>
                <FormLabel className="text-foreground/80">Número de Teléfono</FormLabel>
                <FormControl>
                  <Input type="tel" placeholder="+1 (555) 000-0000" className="bg-background/50 border-border/30 focus-visible:border-primary" {...field} />
                </FormControl>
                <FormMessage />
              </FormItem>} />
        </div>
      </div>

      {submitError && <div className="p-4 bg-destructive/10 border border-destructive/20 rounded-md">
          <p className="text-destructive text-sm">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full sm:w-auto px-8 py-6 text-base tracking-wide uppercase font-semibold">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Enviando...
          </> : 'Solicitar Información'}
      </Button>
    </Form>;
}
export default function PromoInquiryForm() {
  return <section id="promoinquiryform" className="bg-background py-24 px-6 relative overflow-hidden">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[400px] bg-primary/5 blur-[120px] rounded-lg pointer-events-none" />
      
      <div className="max-w-6xl mx-auto relative z-10">
        <Card className="bg-card border-border/20 shadow-2xl overflow-hidden rounded-2xl">
          <div className="grid lg:grid-cols-5 min-h-[600px]">
            
            {}
            <div className="lg:col-span-2 bg-background/40 p-10 lg:p-16 flex flex-col justify-center border-b lg:border-b-0 lg:border-r border-border/10 relative overflow-hidden">
              {}
              <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-primary/50 via-primary to-primary/50" />
              
              <div className="space-y-6 relative z-10">
                <div className="inline-flex items-center space-x-2 text-primary mb-4">
                  <Sparkles className="size-5" />
                  <span className="text-sm font-medium tracking-widest uppercase">Tu viaje, nuestra pasión</span>
                </div>
                
                <h2 className="font-serif text-4xl lg:text-5xl text-foreground leading-tight">Reserva tu<br /><span className="text-primary italic">Promoción</span></h2>
                
                <p className="text-muted-foreground text-lg leading-relaxed">Completa el formulario con tu información y te contactaremos.<br />Evacua tus dudas sin compromiso y reserva tu Viaje Perfecto.</p>
              </div>
            </div>

            {}
            <div className="lg:col-span-3 p-10 lg:p-16 bg-card flex flex-col justify-center">
              <FormProvider formId="promo_inquiry_viaje_perfecto" sectionName="Promo Inquiry Section" defaultValues={{
              category: "Aéreo",
              name: "",
              email: "",
              phone: ""
            }} submitText="Solicitar Información" successMessage="¡Gracias por su interés! Hemos recibido su consulta y nuestro equipo se pondrá en contacto con usted a la brevedad para discutir las opciones de talento.">
                <InquiryFormContent />
              </FormProvider>
            </div>
            
          </div>
        </Card>
      </div>
    </section>;
}